import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {
  ErrorPage,
  AdultPage,
  JackpotPage,
  LandingPage,
  ProfilePage,
  ReferralPage,
  LotteryAllAtOncePage,
  ForbiddenCountryPage,
  AccountPage,
  SettingsPage,
} from './pages';
// import { ForbiddenCountryRoute, PATH } from '@shared/app';
import { ForbiddenCountryRoute, PageOutlet, PATH, ProtectedRoute } from 'lotto-shared';

export const AppRouter = () => {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path={PATH.FORBIDDEN_COUNTRY} element={<ForbiddenCountryPage />} />

        <Route element={<ForbiddenCountryRoute />}>
          <Route path={PATH.ADULT} element={<AdultPage />} />
          <Route path={PATH.LANDING} element={<LandingPage />} />
          <Route path={PATH.ERROR} element={<ErrorPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<PageOutlet />}>
              <Route path={PATH.PROFILE} element={<ProfilePage />} />
              {/* <Route path={PATH.LOTTERY_IN_TURN} element={<LotteryInTurnPage />} /> */}
              <Route path={PATH.LOTTERY_ALL_AT_ONCE} element={<LotteryAllAtOncePage />} />
              <Route path={PATH.JACKPOT} element={<JackpotPage />} />
              <Route path={PATH.REFERRAL} element={<ReferralPage />} />
              <Route path={PATH.ACCOUNT} element={<AccountPage />} />
              <Route path={PATH.SETTINGS} element={<SettingsPage />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};
